import Suspense from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Layout from './Layout.js';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.js';
import Miscellanious from './pages/Miscellanious.js';
import Visual from './pages/Visual.js';
import Audio from './pages/Audio.js';
import DrawingClub from './pages/DrawingClub.js';
import Secret from './pages/Secret.js';
import { CookiesProvider } from 'react-cookie';
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home key={1}/>} />
          <Route path="Visual" element={<Visual key={2}/>} />
          <Route path="Audio" element={<Audio key={3}/>} />
          <Route path="Miscellanious" element={<Miscellanious key={4}/>} />
          <Route path="DrawingClub" element={<DrawingClub key={5}/>} />
          <Route path="Secret" element={<Secret key={6}/>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <App />
    </CookiesProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
